export const distributor_initialState = {
    Name: "",
    Code: "QDS",
    ABN: "",
    BuildingLicence: "",
    Email: "",
    Phone: "",
    Logo: "",
    LYVESAccount: "",
    Address: {
        FormattedAddress: "",
        StreetNumber: "",
        Street: "",
        Suburb: "",
        State: "",
        PostCode: "",
        LatLng: "",
    },
};

export const customer_initialState = {
    JobName: "",
    FirstName: "",
    LastName: "",
    Phone: "",
    Email: "",
    Type: "",
    Address: {
        FormattedAddress: "",
        StreetNumber: "",
        Street: "",
        Suburb: "",
        State: "",
        PostCode: "",
        LatLng: "",
    },
};

export const QUOTE_PARAMETER_SECTIONS = {
    MATERIAL_PARAMETERS: "MATERIAL_PARAMETERS",
    PRICING_PARAMETERS: "PRICING_PARAMETERS",
    ENGINEERING: "ENGINEERING",
    BOM: "BOM",
    DOCUMENTS: "DOCUMENTS",
};

export const quote_parameters_initialState = {
    BuildingSurveyor: "",
    DeliveryNotes: "",
    DeliveryDate: "",
    SalesRepID: "",
    DistributorID: "",
    AlternateID: "",
    FreeStanding: false,
    ShowFlatPostDimensions: 1,
    OrderLocation: "Mile End - SA",
    [QUOTE_PARAMETER_SECTIONS.MATERIAL_PARAMETERS]: {
        NoBulkPacking: 1,
    },
    [QUOTE_PARAMETER_SECTIONS.ENGINEERING]: {},
    [QUOTE_PARAMETER_SECTIONS.BOM]: {
        SystemList: {},
        OrderList: {},
        QuoteData: null,
        FreightPOA: {},
    },
    [QUOTE_PARAMETER_SECTIONS.DOCUMENTS]: {
        "3DScreenShots": [],
        showElevations: true,
        showQrLink: true,
    },
    [QUOTE_PARAMETER_SECTIONS.PRICING_PARAMETERS]: {
        MaterialFixedPrice: 0,
        InstallationFixedPrice: 0,
        ExtraCostsFixedPrice: 0,
        OverallDiscount: 0,
        OverallDiscountPercentage: 0,
        Promotion: null,
        IncludePackingAndDelivery: true,
        IncludeGST: true,
        PaymentStructure: null,
        OutputSummary: {
            MaterialBase: 0,
            TotalIncGST: 0,
        },
    },
};

export const SITE_PARAMETER_SECTIONS = {
    HouseParameters: "HouseParameters",
    ExistingStructure: "ExistingStructure",
};

export const site_parameters_initialState = {
    UseType: "Domestic",
    ImportanceLevel: "", // default is 2 set in validateSiteData
    AddressSameAsMailingAddress: true,
    Address: {
        FormattedAddress: "",
        StreetNumber: "",
        Street: "",
        Suburb: "",
        State: "",
        PostCode: "",
        LatLng: "",
    },
    ExistingStructure: {
        RoofPitch: "22.5",
        RoofType: "Steel",
        RoofColour: "#bcbcbaff",
        FasciaMaterial: "Timber",
        AttachmentType: "Timber Fascia Drop", // attchment type
        FasciaHeight: 185,
        WallHeight: 2400,
        EaveDepth: 600,
        CladdingWidth: 150,
        WallType: "Blank",
        FrameType: "Timber Frame - Brick Veneer",
        WallColour: "#bcbcbaff",
        SteelFrameWarning: "",
        GutterOffset: 90,
        GutterWidth: 125,
        FloorType: "Blank",
        FloorColour: "#bcbcbaff",
        GroundType: "Granular Soil with Some Clay (Type B)",
    },
    WindData: {
        WindZone_UseAS1170: false,
        WindZoneAS1170: null,
        WindZoneAS4055: null,
        WindZone: "N3",
        Blocking: 1,
    },
    RiserBracketSpacing: 900,
    RiserFullHeight: 1,
    FlyoverFullHeight: 1,
    FasciaBracketDefault: "BK26DEG",
    RafterBracketSpacing: 1200,
    FlyoverBracketSpacing: 6100,
    CarportRiserBracketSpacing: 900,
    RafterBracketDefault: "BK34<R1>G",
    PitchAngleForSpecialBracket: 6,
    PitchAngleForSquareCutBeams: 6,
    BracketAllowance: 5,
    SizeAdjustment: 1,
    MatchArea: -1,
    DeliveryNotes: "",
    SpliceOffset: 0,
    CONST_ON_TOP_BEAM: "656510",
    CONST_GABLE_HIP_ON_TOP_BEAM: "656510",
    CONST_STRUT_BEAM: "656510",
    CONST_SLIMLINE_INFILL_PORTAL: "656510",
    CONST_SKILLION_ROOF_PURLIN: "656510",
    CONST_SKILLION_ROOF_END_POST: "1586510",
    CONST_SKILLION_ROOF_END_POST: "2086510",
    CONST_GABLE_HIP_ON_TOP_PURLIN: "656510",
    CONST_GABLE_HIP_ON_TOP_BEAM: "656510",
    CONST_GABLE_HIP_GAZEBO_POST: "656510",
    CONST_FREESTANDING_SLAT_POST: "50mm x 50mm x 3mm P/C",
    CONST_FREESPAN_PURLIN: "656510",
    CONST_CURVED_ROOF_ON_TOP_PURLIN: "656510",
    CONST_CANTILEVER_ROOF_BACK_PURLIN_BEAM: "656510",
    CONST_DOWNPIPE_LOW_HEIGHT: 200,
    CONST_DOWNPIPE_OFFSET_TOLERANCE: 175,
    CONST_POST_EXTRA: 100,
    AutoExtendBeamsToWall: 1,
    CONST_BEAM_CUT_EXTRA: 30,
    CONST_FREESPAN_BEAM_CUT_EXTRA: 30,
};

export const design_parameters_initialState = {
    Freestanding: false,
    GazeboMode: 0,
    BBQMode: 0,
    DeckMode: 0,
    ExtraAreaStart: "14",
    SplicingLength: 9000,
    AutoAddBeamBreakPost: 1,
    ShowCustomCutoutDimensions: 1,
    USE_BOM_SPLICING: true,
    USE_ATTACHMENTS_2: false,
    UseAreaJoinExtensions: true,
    DesignTemplate: {
        TemplateKey: null,
        Name: null,
        KitPricingIndexCode: null,
    },
};

export const BASIC_SPECS_SECTIONS = {
    EXISTING_STRUCTURE: "EXISTING_STRUCTURE",
    SHAPE: "SHAPE",
    BEAMS_AND_POSTS: "BEAMS_AND_POSTS",
    POSTMODIFICATIONS: "POSTMODIFICATIONS",
    BEAMMODIFICATIONS: "BEAMMODIFICATIONS",
    BEAMSPECMODIFICATIONS: "BEAMSPECMODIFICATIONS",
    BEAMADJUSTMENTS: "BEAMADJUSTMENTS",
    BEAMWALLEXTENDS: "BeamWallExtends",
    ATTACHMENTS: "ATTACHMENTS",
    ROOF_SHEETING: "ROOF_SHEETING",
    GUTTERS_AND_DOWNPIPES: "GUTTERS_AND_DOWNPIPES",
    FOOTINGS: "Footings",
    DECK_PARAMETERS: "DECK_PARAMETERS",
    GABLE_PARAMETERS: "GABLE_PARAMETERS",
    ENGINEERING_AND_DESIGN: "ENGINEERING_AND_DESIGN",
    SKYLIGHTS: "SKYLIGHTS",
    OPTIONS: "OPTIONS",
};

export const basic_specs_initialState = {
    // matched to VQU
    EXISTING_STRUCTURE: {
        // SITE_FasciaType: "Beam", // attchment type
    },
    SHAPE: {
        DesignType: "Flat Roof",
        DesignSubType: "Type 4",
        Mode: "", //allow for galv or other modes
        SheetDirection: "Front",
        SetType4: 1,
        Length: 6000,
        Depth: 3000,
        Height: 2400,
        OH_Front: 0,
        OH_Back: 0,
        OH_Left: 0,
        OH_Right: 0,
        OH_Front_Sheet: 0,
        OH_Back_Sheet: 0,
        OH_Left_Sheet: 0,
        OH_Right_Sheet: 0,
        RoofPitch: 1,
        RotateArea: 0,

        HipAngle1: 45,
        HipAngle2: 45,
        RoofType1: "Gable",
        RoofType2: "Gable",
        PitchedRoofShear: "",
        AREAJOIN: {
            JoinType: "Offset",
            JoinAngle: 0,
            JoinOffset: 0,
            // JoinArea: 0,
            AngleJoinHipCapping: 1,
            StructuralBackChannel: 1,
            OmitJoinPost: 1,
            HipJunctionDir: 0,
            JoinGutter: 2,
            JoinBoxGutterWidth: 190,
            JoinOffsetP: "(0,0)",
            JoinOffsetGlobal: 1,
            MultipleAreaBeamList: "Box",
        },
        CUTOUTS: {
            "BackLeft-CutoutType": "None",
            "BackLeft-WidthX": 1000,
            "BackLeft-WidthY": 1000,
            "BackLeft-WidthD": 700,
            "BackLeft-Offset": 0,
            "BackLeft-Attachment": 1,
            "BackLeft-AttachmentY": 1,
            "BackLeft-HasBeamX": 1,
            "BackLeft-HasBeamY": 1,
            "BackLeft-HasGutterX": 1,
            "BackLeft-HasGutterY": 1,
            "BackLeft-HasPostsX": 1,
            "BackLeft-HasPostsY": 1,
            "BackLeft-Overhang": 0,
            "BackLeft-OverhangY": 0,
            "BackLeft-0-CustomHasBeam": 1,
            "BackLeft-0-CustomHasGutter": 1,
            "BackLeft-0-CustomHasPosts": 1,
            "BackMid-CutoutType": "None",
            "BackMid-WidthX": 4000,
            "BackMid-WidthY": 2000,
            "BackMid-WidthD": 1000,
            "BackMid-Offset": 1000,
            "BackMid-Attachment": 1,
            "BackMid-AttachmentY": 1,
            "BackMid-AttachmentY2": 1,
            "BackMid-AttachmentA": 1,
            "BackMid-AttachmentA2": 1,
            "BackMid-HasBeamX": 1,
            "BackMid-HasBeamY": 1,
            "BackMid-HasBeamY2": 1,
            "BackMid-HasGutterX": 1,
            "BackMid-HasGutterY": 1,
            "BackMid-HasGutterY2": 1,
            "BackMid-HasPostsX": 1,
            "BackMid-HasPostsY": 1,
            "BackMid-Overhang": 0,
            "BackMid-OverhangY": 0,
            "BackRight-CutoutType": "None",
            "BackRight-WidthX": 1000,
            "BackRight-WidthY": 1000,
            "BackRight-WidthD": 700,
            "BackRight-Offset": 0,
            "BackRight-Attachment": 1,
            "BackRight-AttachmentY": 1,
            "BackRight-HasBeamX": 1,
            "BackRight-HasBeamY": 1,
            "BackRight-HasGutterX": 1,
            "BackRight-HasGutterY": 1,
            "BackRight-HasPostsX": 1,
            "BackRight-HasPostsY": 1,
            "BackRight-Overhang": 0,
            "BackRight-OverhangY": 0,
            "BackRight-0-CustomHasBeam": 1,
            "BackRight-0-CustomHasGutter": 1,
            "BackRight-0-CustomHasPosts": 1,
            "FrontLeft-CutoutType": "None",
            "FrontLeft-WidthX": 1000,
            "FrontLeft-WidthY": 1000,
            "FrontLeft-WidthD": 700,
            "FrontLeft-Offset": 0,
            "FrontLeft-Attachment": 0,
            "FrontLeft-AttachmentY": 0,
            "FrontLeft-HasBeamX": 1,
            "FrontLeft-HasBeamY": 1,
            "FrontLeft-HasGutterX": 1,
            "FrontLeft-HasGutterY": 1,
            "FrontLeft-HasPostsX": 1,
            "FrontLeft-HasPostsY": 1,
            "FrontLeft-Overhang": 0,
            "FrontLeft-OverhangY": 0,
            "FrontLeft-0-CustomHasBeam": 1,
            "FrontLeft-0-CustomHasGutter": 1,
            "FrontLeft-0-CustomHasPosts": 1,
            "FrontMid-CutoutType": "None",
            "FrontMid-WidthX": 1000,
            "FrontMid-WidthY": 1000,
            "FrontMid-WidthD": 700,
            "FrontMid-Offset": 0,
            "FrontMid-Attachment": 0,
            "FrontMid-AttachmentY": 0,
            "FrontMid-HasBeamX": 1,
            "FrontMid-HasBeamY": 1,
            "FrontMid-HasGutterX": 1,
            "FrontMid-HasGutterY": 1,
            "FrontMid-HasPostsX": 1,
            "FrontMid-HasPostsY": 1,
            "FrontMid-Overhang": 0,
            "FrontMid-OverhangY": 0,
            "FrontRight-CutoutType": "None",
            "FrontRight-WidthX": 1000,
            "FrontRight-WidthY": 1000,
            "FrontRight-WidthD": 700,
            "FrontRight-Offset": 0,
            "FrontRight-Attachment": 0,
            "FrontRight-AttachmentY": 0,
            "FrontRight-HasBeamX": 1,
            "FrontRight-HasBeamY": 1,
            "FrontRight-HasGutterX": 1,
            "FrontRight-HasGutterY": 1,
            "FrontRight-HasPostsX": 1,
            "FrontRight-HasPostsY": 1,
            "FrontRight-Overhang": 0,
            "FrontRight-OverhangY": 0,
            "FrontRight-0-CustomHasBeam": 1,
            "FrontRight-0-CustomHasGutter": 1,
            "FrontRight-0-CustomHasPosts": 1,
        },
        isGable: false,
    },
    ATTACHMENTS: {
        AttachmentLeft: 0,
        AttachmentRight: 0,
        AttachmentTop: 1,
        AttachmentBottom: 0,
        PARTIAL_ATTACHMENTS: [],
        AttachmentModifications: [
            {
                Ref: "Back 1",
                Name: "Back 1",
                HasEaveWidth: 0,
                EaveWidth: 600,
                HasWallHeight: 0,
                WallHeight: 2100,
                HasFasciaType: 1,
                AttachmentType: "Fascia with Receiver Channel",
                AttachmentVariation: "Timber Fascia",
                FasciaType: "Timber Fascia Drop",
                HasBeam: 1,
                WallOnly: 0,
                vOffset: 100,
                hOffset: 300,
                NumBrackets: 0,
                HasNumBrackets: 0,
                AllowRSBLC: 0,
                AttachmentHOffset: 0,
            },
        ],
    },
    BEAMS_AND_POSTS: {
        BeamSettingMode: 1,
        BeamType1: "1586510",
        BeamList1: "Gazebo Beam",
        BeamName1: "Fascia",
        BeamCol1: "TBA",
        Beam1ColourSelectionMade: true,
        BeamColMatchBeam: "Match Post",
        BeamType2: "1586510",
        BeamList2: "Gazebo Beam",
        BeamName2: "Purlin",
        BeamCol2: "TBA",
        BeamCol2MatchBeam: "Match Post",
        BeamType3: "1586510",
        BeamList3: "Box",
        BeamName3: "Rafter",
        BeamCol3: "TBA",
        BeamCol3MatchBeam: "Match Post",
        BeamType4: "1586510",
        BeamList4: "Fascia Box",
        BeamName4: "",
        BeamCol4: "Classic Cream",
        BeamCol4MatchBeam: "Match Post",
        MultipleAreaBeamType: "1586510",
        PostType: "656510",
        PostList: "Gazebo Post",
        PostCol: "TBA",
        PostColourSelectionMade: false,
        PostColMatchBeam: "TBA",
        BeamSpacing: "9000",
        PostSpacing: "30000",
        SpacingsLocked: true,
        MembersLocked: false,
        OmitLeftBeam: 0,
        OmitRightBeam: 0,
        ExternalConnectors: 1,
        PostExternalConnectors: 0,
        PostAlignment: 0,
        AlignPostsToBeams: 1,
        MatchSideBeams: 0,
        PurlinSpacing: 600, // represents joist spacing
        NumMiddlePosts: 0,
        NumInternalRafters: 0,
        RemoveInternalRaftersWithNoPurlins: 0,
        NumPortals: 3,
        NumPurlins: -1,
        NumExtraPortals: 0,
        NumExtraPurlins: 0,
        HasRidgeBeam: 0,
        SlimlineGable: 0,
        CornerPostsFullHeight: 1,
        CornerPostsFullHeightOffset: 150,
        IntermediatePostsFullHeight: 0,
        FootingType: "Concrete In",
        FootingShape: "Square",
        NumExtraPostsFront1: 0,
        NumExtraPostsBack1: 0,
        NumExtraPostsCFLX: 0,
        NumExtraPostsCFRX: 0,
        NumExtraPostsCBLX: 0,
        NumExtraPostsCBRX: 0,
        AutoAddBeamBreakPost: 1,
        PortalPostType: 0,
        DoubleIntermediateRafters: 0,
        GableRafterApexFlushCut: 0,
        GableRafterBaseFlushCut: 0,
        CollarTie: 0,
        CollarTieBeam: "FL10011",
        CollarTieBracket: "CTC10",
        CollarTiePosition: 0.7,
        CollarTieEnd1: -1,
        CollarTieEnd2: -1,
        RidgePurlinsNoBrackets: 0,
        ApexBracketInternal: "",
        ApexBracketEnd: "",
        GableTopPurlinOffset: 75,
        IntRafterBracketClearance: 400,
        JackRafters: 0,
        // NumExtraPostsFront1: 0,
    },
    ROOF_SHEETING: {
        SECTION_NAME: "ROOF_SHEETING",
        RoofType: "Cent 310 Deck",
        RoofGroupType: "Cent 310 Deck",
        RoofSubType: "Colorbond 0.42",
        RoofSpan: "No Foot Traffic",
        RoofColourSelectionMade: false,
        RoofSheetColour: "TBA",
        RoofRolling: "Top Side", // for legacy
        ReverseRoll: false,
        SkylightType: "Cent 310 Deck Polycarbonate",
        SkylightSubType: "",
        SkylightColour: "Opal",
        SkylightColourSelectionMade: false,
        SkylightIsSelected: false,
        SkylightRolling: "Under Side",
        SheetLaying: 0,
        SheetLayingOffset: 0,
        FlashingColour: "TBA",
        FlashingColourMatchString: "Match Roofsheet",
        RidgeColour: "TBA",
        RidgeColourMatchString: "Match Barge",
        RollTopRidge: false,
        RidgeCappingCode: "",
        ValleyFlashingCode: "",
        DownlightData: { Amount: 1, ControlType: "Automatic", DownlightSelection: "" },
        RoofSheetData: {
            min_pitch: 1,
            max_overhang: 300,
            coverage: 310,
            texture_filename: "cdeck.png",
            skylight_texture_filename: "cdeck_skylight.png",
            gutter_return_not_required: "",
        },
        MaxEndSheetSpan: 0,
        MaxInternalSheetSpan: 0,
    },
    GUTTERS_AND_DOWNPIPES: {
        SECTION_NAME: "GUTTERS_AND_DOWNPIPES",
        GutterB: 1,
        GutterF: 1,
        GutterL: 1,
        GutterR: 1,
        GutterType: "",
        GutterColourSelectionMade: false,
        GutterIsSelected: false,
        GutterCol: "TBA",
        BoxGutterWidth: "190",
        DoubleBoxGutterWidth: "250",
        BoxGutterColour: "TBA",
        BoxGutterColourMatchBeam: "Match Fascia",
        DownpipeType: "65mm Square Downpipe",
        DownpipeCol: "TBA",
        DownpipeColourSelectionMade: false,
        DownpipeIsSelected: false,
        EasyFixMitres: 1, // ALWAYS 1, always ADD if there is a code in the materials list
        HandmadeMitres: 1, // coopted for special corners
        SlottedGutter: 0,
        GutterWithReturn: 0,
        FullLengthGutter: 0,
        AddAutomaticDownpipes: 1,
        AttachmentGutterF: 0,
        AttachmentGutterB: 0,
        AttachmentGutterL: 0,
        AttachmentGutterR: 0,
        GutterReturnNotRequired: 0,
        GutterVerticalAlign: 0,
        Downpipes: [],
    },
    DECK_PARAMETERS: {
        JoistsOnTop: "0",
        PostOffset: "0",
        DeckBracing: [],
        DeckPosts: [],
        StrapBraceCode: "",
        StrapBraceRollLength: 30,
        WireBraceCode: "",
        WireBraceRollLength: 30,
        RodBraceCode: "",
        FloorBraceCode: "",
        FloorBraceArea: 20,
    },
    GABLE_PARAMETERS: {
        HasInfillBeam1: 1,
        HasInfillBeam2: 1,
        HipPortalPost1: "1",
        HipPortalPost2: "1",
        InfillBeamHigh: "0",
        InfillBeamType: "656510",
        InfillEndAlign1: "1",
        InfillEndAlign2: "1",
        InfillFlashingColour1: "Classic Cream",
        InfillFlashingColourMatch1: "Match Rafter",
        InfillFlashingColour2: "Classic Cream",
        InfillFlashingColourMatch2: "Match Rafter",
        InfillNotSupplied: "0",
        TrussInfill1: "Plain Smooth",
        TrussInfill2: "Plain Smooth",
        InfillInset1: 0,
        InfillInset2: 0,
        InfillOnTopBeam1: "",
        InfillOnTopBeam2: "",
        TrussInfillColour1: "Plain",
        TrussInfillColour2: "Plain",
        TrussInfillDisplayColour1: null,
        TrussInfillDisplayColour2: null,
        DownlightFlashing: "1",
        SoakerFlashingWidth: 150,
        HasInfillStrut1: 1,
        HasInfillStrut2: 1,
        DutchGableBeamInset: 0,
        DutchGableBeamInsetPosition: 0.6,
        DutchGablePosition: 0.25,
        DutchGableCollarTieBeam: "FL15015",
        GableRidgeBackChannel: true,
    },
    ENGINEERING_AND_DESIGN: {
        RiserBracketSpacing: "1200",
        CarportRiserBracketSpacing: "1200",
    },
    OPTIONS: {
        Door1: "None",
        Door2: "None",
        FBackspanL: "600",
        FBackspanR: "600",
        FootingDepth: "950",
        FootingSelected: "True",
        FootingWidth: "900",
        FOverhangL: "0",
        FOverhangR: "0",
        FrontOpening: "3",
        FrontOpeningType: "Door",
        HasCrossBracing: "0",
        HasFinial1: "0",
        HasFinial2: "0",
        JoinArea: "0",
        LeftOpening: "0",
        LeftOpeningType: "Door",
        LBackspanB: "600",
        LBackspanF: "600",
        MaxPortalSpacing: "0",
        MembersLocked: "False",
        NumExtraFinials: "0",
        RBackspanB: "600",
        RBackspanF: "600",
        RightOpening: "0",
        RightOpeningType: "Door",
        ROverhangB: "0",
        ROverhangF: "0",
        WallType: "TL5",
        SlatColour: "Monument",
        SlatFromTopLastSelection: "0",
        SlatNumSlatsLast: "15",
        SlatRetainerSpacing: "10",
        SlatType: "FS70",
    },
    SKYLIGHTS: [],
    BEAMMODIFICATIONS: [],
    BEAMSPECMODIFICATIONS: [],
    BEAMADJUSTMENTS: [],
    DECORATIONS: [],
    POSTMODIFICATIONS: [],
    POSTADJUSTMENTS: [],
    DrawingNotes: [],
    NewBeams: [],
    SlatPanels: [],
    Acknowledgements: {},
};

export const notes_initialState = [
    {
        quote: "CEN0000007",
        timestamp: 1602408500000,
        system_generated: true,
        user: "System",
        user_code: "f",
        text: "this quote was created",
        attachments: [],
    },
    {
        quote: "CEN0000007",
        timestamp: 1602808620000,
        system_generated: false,
        userID: 519,
        user: "Kevin Chan",
        user_code: "KC",
        text: "Customer Called: Changed colours to Shale Grey. What is it like when the message is longer. Changed colours to Shale Grey. What is it like when the message is longer. .Changed colours to Shale Grey. What is it like when the message is longer. .Changed colours to Shale Grey. What is it like when the message is longer. ",
        attachments: [
            {
                image: true,
                url: "images/SampleImage1.jpg",
                thumb: "images/SampleImage1_thumb.jpg",
            },
            {
                image: false,
                url: "https://fielderscentenary.com.au/wp-content/uploads/CentenaryBrochureRevised.pdf",
                thumb: "https://fielderscentenary.com.au/wp-content/uploads/C-Deck-roofing-profile_web-716x800.jpg",
            },
            {
                image: true,
                url: "images/SampleImage2.jpg",
                thumb: "images/SampleImage2_thumb.jpg",
            },
        ],
    },
    {
        quote: "CEN0000007",
        timestamp: 1602808650000,
        system_generated: false,
        user: "Kevin Chan",
        user_code: "KC",
        text: "Customer Called: Changed colours to Shale Grey. What is it like when the message is longer. Changed colours to Shale Grey. What is it like when the message is longer. .Changed colours to Shale Grey. What is it like when the message is longer. .Changed colours to Shale Grey. What is it like when the message is longer. ",
        attachments: [
            {
                image: true,
                url: "images/SampleImage1.jpg",
                thumb: "images/SampleImage1_thumb.jpg",
            },
            {
                image: false,
                url: "https://fielderscentenary.com.au/wp-content/uploads/CentenaryBrochureRevised.pdf",
                thumb: "https://fielderscentenary.com.au/wp-content/uploads/C-Deck-roofing-profile_web-716x800.jpg",
            },
            {
                image: true,
                url: "images/SampleImage2.jpg",
                thumb: "images/SampleImage2_thumb.jpg",
            },
        ],
    },
    {
        quote: "CEN0000007",
        timestamp: 1602808650000,
        system_generated: false,
        user: "Kevin Chan",
        user_code: "KC",
        text: "Customer Called: Changed colours to Shale Grey. What is it like when the message is longer. Changed colours to Shale Grey. What is it like when the message is longer. .Changed colours to Shale Grey. What is it like when the message is longer. .Changed colours to Shale Grey. What is it like when the message is longer. ",
        attachments: [
            {
                image: true,
                url: "images/SampleImage1.jpg",
                thumb: "images/SampleImage1_thumb.jpg",
            },
            {
                image: false,
                url: "https://fielderscentenary.com.au/wp-content/uploads/CentenaryBrochureRevised.pdf",
                thumb: "https://fielderscentenary.com.au/wp-content/uploads/C-Deck-roofing-profile_web-716x800.jpg",
            },
            {
                image: true,
                url: "images/SampleImage2.jpg",
                thumb: "images/SampleImage2_thumb.jpg",
            },
        ],
    },
];
